module.exports = __webpack_public_path__ + "img/noCon.dddba24b.png";